import { Injectable } from '@angular/core';

/*
  SearchTermMatcher service for extensibility with the auto complete.

  This is the default behavior.

  Can be overriden in injector with custom matcher.

  This matcher specifically is not case sensitive.
*/
@Injectable()
export class SearchTermMatcherService {
  constructor() {}

  public isMatch(searchTerm: string, searchableTerms: string[]): boolean {
    return searchableTerms.some(
      term => term.toUpperCase().indexOf(searchTerm.toUpperCase()) > -1
    );
  }

  public isExactMatch(searchTerm: string, searchableTerms: string[]) {
    return searchableTerms.some(
      term => term.toUpperCase() === searchTerm.toUpperCase()
    );
  }
}

/*
  Service to return formatted html string for autocomplete display
  such that the letters that match are emboldened

  e.g.

  searchTerm = "fo"

  formattedDisplay=`<span class="bold-letter">F</span><span class="bold-letter">o</span>obar`

*/
@Injectable()
export class SearchTermDisplayFormatterService {
  constructor() {}

  // HTML has an issue with white space so we will use this function
  // to replace white space characters with &nbsp; as well as any other
  // weird characters we need to replace.
  private _formatHtmlCharacter(char) {
    if (char === ' ') {
      return '&nbsp;';
    }
    return char;
  }

  public formatAsHTML(
    searchTerm: string,
    display: string,
    htmlClass: string = 'bold-letter'
  ): string {
    if (!searchTerm || !searchTerm.length) {
      return display;
    }
    let result = '';
    const searchChars = searchTerm.split('');
    for (let i = 0; i < display.length; i++) {
      if (
        searchChars.length > 0 &&
        display.toLowerCase()[i] === searchChars[0].toLowerCase()
      ) {
        result += `<span class="${htmlClass}">${this._formatHtmlCharacter(
          display[i]
        )}</span>`;
        searchChars.shift();
      } else {
        result += this._formatHtmlCharacter(display[i]);
      }
    }
    return result;
  }
}
